
import { Spinner, SpinnerProps } from "@chakra-ui/react"

interface WaitingSpinnerProps extends SpinnerProps {}

const WaitingSpinner = (props: WaitingSpinnerProps) => {
    return (
        <Spinner
            borderWidth='4px'
            animationDuration='0.65s'
            color='blue.500'
            {...props}
        />
    )
}

export default WaitingSpinner
